export const changesPanelStyles = {
  position: 'sticky',
  top: 0,
  display: 'flex',
  flexDirection: 'column',
  gap: '16px',
  minWidth: 0,
  padding: '14px',
  borderRadius: ({ shape }) => shape.radius.l,
  border: '1px solid',
  borderColor: ({ palette }) => palette.divider,
};

export const panelSectionStyles = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  gap: '8px',
};
